import { useState } from "react";

/**
 * Custom hook for showing toast messages.
 * Usage:
 *   const [toast, showToast] = useToast();
 *   showToast("Message", "success");
 *   // Render toast if toast.open
 */
export function useToast() {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    type: "info",
  });
  const showToast = (message, type = "info") => {
    setToast({ open: true, message, type });
    setTimeout(
      () => setToast({ open: false, message: "", type: "info" }),
      2000
    );
  };
  return [toast, showToast];
}
